import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout, Section } from "./LegalLayout";

const Consent = () => (
  <LegalLayout
    title="Согласие на обработку персональных данных"
    updated="14 июня 2026 г."
  >
    <Section title="1. Общие положения">
      <p>
        Регистрируясь на сайте <strong>swingmentor.pro</strong>, оплачивая
        услуги или загружая видеозаписи, пользователь (далее — «Субъект»),
        действуя свободно, своей волей и в своём интересе, в соответствии со
        ст. 9 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных
        данных» даёт согласие индивидуальному предпринимателю КОКОВУ
        АЛЕКСАНДРУ ДМИТРИЕВИЧУ (ОГРНИП: 325784700333162, ИНН: 784302022304,
        адрес: Россия, г. Санкт-Петербург, пос. Комарово, Цветочная 2А; далее
        — «Оператор») на обработку своих персональных данных.
      </p>
    </Section>

    <Section title="2. Перечень персональных данных">
      <ul>
        <li>имя, фамилия;</li>
        <li>адрес электронной почты;</li>
        <li>гольф-гандикап;</li>
        <li>
          исходные и обработанные видеозаписи гольф-свинга, изображения фаз,
          текстовые рекомендации, оценки и иные результаты анализа;
        </li>
        <li>сведения о платежах (факт, сумма, идентификатор платежа).</li>
      </ul>
    </Section>

    <Section title="3. Цели обработки">
      <ul>
        <li>регистрация и идентификация на сайте swingmentor.pro;</li>
        <li>
          оказание услуг автоматизированного анализа техники гольф-свинга и
          предоставление рекомендаций;
        </li>
        <li>приём платежей и направление кассовых чеков;</li>
        <li>поддержка пользователей и ответы на обращения;</li>
        <li>исполнение требований законодательства РФ.</li>
      </ul>
    </Section>

    <Section title="4. Перечень действий и способы обработки">
      <p>
        Согласие даётся на совершение следующих действий: сбор, запись,
        систематизация, накопление, хранение, уточнение (обновление,
        изменение), извлечение, использование, передача (предоставление,
        доступ) лицам, указанным в разделе 4{" "}
        <Link to="/legal/privacy">Политики конфиденциальности</Link>,
        обезличивание, блокирование, удаление, уничтожение — с использованием
        средств автоматизации. Обработка видеозаписей осуществляется
        автоматизированно, включая обработку с использованием технологий
        искусственного интеллекта.
      </p>
      <p>
        Сбор, запись, систематизация, накопление, хранение, уточнение и
        извлечение персональных данных осуществляются с использованием баз
        данных на территории Российской Федерации. Субъект также соглашается
        на временную передачу видеозаписи и технического идентификатора
        задания поставщикам вычислительной и ИИ-инфраструктуры, в том числе
        находящимся за пределами Российской Федерации, исключительно для
        выполнения анализа. Данные аккаунта и платёжные сведения вместе с
        видеозаписью не передаются, а временная копия удаляется после
        завершения попытки обработки.
      </p>
    </Section>

    <Section title="5. Срок действия и отзыв согласия">
      <p>
        Согласие действует с момента его предоставления до достижения целей
        обработки либо до его отзыва. Исходные видеозаписи и временные файлы
        удаляются после завершения анализа или окончательного завершения задания
        с ошибкой. Обработанное видео хранится при включённой пользователем
        настройке сохранения — до отключения этой настройки или удаления
        аккаунта. Остальные результаты анализа хранятся в истории до удаления
        аккаунта или исполнения подтверждённого запроса на удаление.
      </p>
      <p>
        Согласие может быть отозвано в любой момент путём направления заявления на{" "}
        <a href="mailto:info@swingmentor.pro">info@swingmentor.pro</a> с темой
        «Отзыв согласия». Оператор прекращает обработку и уничтожает данные в
        течение 30 дней с момента получения отзыва, за исключением данных,
        хранение которых обязательно в силу законодательства РФ (например,
        сведения о платежах).
      </p>
      <p>
        Отзыв согласия может сделать невозможным дальнейшее использование
        сервиса.
      </p>
    </Section>
  </LegalLayout>
);

export default Consent;
